import React from 'react';
import {withRouter} from "react-router-dom";
import {Card, CardBody, CardHeader, Col, Collapse, Row} from "reactstrap";
import SpaceTagGridSlot from "../../../../components/SpaceTagsGridSlot/SpaceTagGridSlot";
import SpaceTagGridActiveSlot from "../../../../components/SpaceTagsGridSlot/SpaceTagGridActiveSlot";
import './work_space_slot_style.scss';
import {MDBDataTable} from "mdbreact";
import {Empty} from "antd";
import EmployeeModal from "../EmployeeModal";
import * as tbl_headers from '../../tbl_colums';
import * as actionCreator from "../../../../store/Action";
import {connect} from "react-redux";
import * as innerRoutes from "../../innerRoutes";
import EmployeeImagePlaceholder from '../../../../assets/img/spacetags/employeeimageplaceholder.jpg';

class WorkSpaceGrid extends React.Component {

  state = {
    employee_modal: false,

    workspace: null,
    workspace_obj: null,
    date: null,
    userReservation: null,
    totalSlotCount: 0,
    slotDetailsList: [],
    employeeDetail: null,
  };

  componentDidMount() {
    if(this.props.workspace !== null) {
      let description = this.props.workspace.description;
      let branch = this.props.workspace.branch.name;
      let building = this.props.workspace.building.name;
      let floor = this.props.workspace.floor.description;
      this.setState({
        workspace: " " + description + "/ " + floor + "/ " + building + "/ " + branch,
        workspace_obj: this.props.workspace
      });
    } else {
      this.props.history.push(innerRoutes.inner_route_spacetags_all_workspace);
    }

    if(this.props.reservation !== null) {
      let date = this.props.reservation.date;
      let userReservation = this.props.reservation.userReservationList;
      let totalSlotCount = this.props.reservation.totalSlotCount;
      let slotDetailsList = [];
      for(let i=0; i<totalSlotCount; i++) {
        let activationDetails = null;
        for(let j = 0; j < userReservation.length; j++) {
          let reservationListElement = userReservation[j];
          if(reservationListElement !== undefined) {
            if(reservationListElement.slotNumber === (i+1)) {
              activationDetails = reservationListElement;
              break;
            }
          }
        }
        let obj = {
          slotId: i+1,
          slotActivation: activationDetails
        };
        slotDetailsList.push(obj);
      }
      this.setState({
        date: date,
        userReservation: userReservation,
        totalSlotCount: totalSlotCount,
        slotDetailsList: slotDetailsList,
      });
    } else {
      if(this.props.workspace === null) {
        this.props.history.push(innerRoutes.inner_route_spacetags_workspace_calender);
      } else {
        let slotDetailsList = [];
        for(let j = 0; j<this.props.workspace.totalSlotCount; j++) {
          let obj = {
            slotId: j+1,
            slotActivation: null
          };
          slotDetailsList.push(obj);
        }
        this.setState({
          date: this.props.reservation_date,
          userReservation: [],
          totalSlotCount: this.props.workspace.totalSlotCount,
          slotDetailsList: slotDetailsList,
        });
      }

    }

  }

  openEmployeeModal = (r) => {
    this.setState({
      employeeDetail: r,
    });
    this.openEmployeeModal_();
  };

  openEmployeeModal_ = () => {
    this.setState({
      employee_modal: !this.state.employee_modal
    });
  };

  render() {

    let{ employee_modal, userReservation, totalSlotCount, slotDetailsList, employeeDetail, workspace, date } = this.state;

    let slot_list = [];

    if(slotDetailsList) {
      slotDetailsList.map((r, i)=>{
        if(r.slotActivation) {
          let slot = <Col xs={4} sm={3} md={2} lg={1} xl={1}><SpaceTagGridActiveSlot key={i} value={r.slotId} call={()=>this.openEmployeeModal(r)}/></Col>;
          slot_list.push(slot);
        } else {
          let slot = <Col xs={4} sm={3} md={2} lg={1} xl={1}><SpaceTagGridSlot key={i} value={r.slotId} call={this.openEmployeeModal}/></Col>;
          slot_list.push(slot);
        }
      });
    }

    let row = [];

    if(userReservation) {
      userReservation.map((r, i)=>{
        let obj = {
          slot: r.slotNumber,
          employee_image:
            <img src={ ( r.photoPath===undefined || r.photoPath===null || r.photoPath==="" )?EmployeeImagePlaceholder:r.photoPath } alt={'Employee image'} width={50}/>,
          employee_name: r.firstName + " " + r.lastName,
          position: r.designation,
          group: r.department,
        };
        row.push(obj);
      });
    }

    let reserved_slot_data = {columns: tbl_headers.RESERVED_SLOTS, rows: row};

    return(
      <div>
        {
          employee_modal?
          <EmployeeModal isOpen={true} data={ this.state.employeeDetail } workspace={ workspace } date={ date } closeModal={this.openEmployeeModal}/>:null
        }
        <div className={'ws_details'}>
          <table>
            <tbody>
            <tr>
              <td className={'sub-header'}>Date</td>
              <td>: {" "} { this.state.date }</td>
            </tr>
            <tr>
              <td className={'sub-header'}>Work Space</td>
              <td>: { this.state.workspace }</td>
            </tr>
            </tbody>
          </table>
        </div>

        <Card>
          <CardHeader>
            Slots
          </CardHeader>
          <Collapse isOpen={true} id="collapseExample">
            <CardBody>

              <div className={'slot-panel'}>
                <Row>

                  {
                    slot_list
                  }

                </Row>
              </div>

            </CardBody>
          </Collapse>
        </Card>

        <Card>
          <CardHeader>
            Reserved Slot Details
          </CardHeader>
          <Collapse isOpen={true} id="collapseExample">
            <CardBody>

              {
                true ?
                  <MDBDataTable
                    searching={true}
                    displayEntries={true}
                    responsive
                    responsiveSm
                    responsiveMd
                    responsiveLg
                    responsiveXl
                    bordered
                    hover
                    data={reserved_slot_data}
                  />
                  : <div className={"align-center fully-width"}>
                    <Empty description={"Records not found"} className={"empty-icon"}/>
                  </div>

              }

            </CardBody>
          </Collapse>
        </Card>



      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  usr_obj: state.userReducer.user,
  workspace: state.workspaceReducer.workspace,
  reservation: state.workspaceReducer.reservationData,
  reservation_date: state.workspaceReducer.reservationDate,
});

const mapDispatchToProps = (dispatch) => {
  return {
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    reservationHandler: (data) => dispatch(actionCreator.workspaceSaveReservationsHandler(data)),
    reservationRemoveHandler: () => dispatch(actionCreator.workspaceRemoveReservationsHandler()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(WorkSpaceGrid));
